import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import esTranslation from 'assets/locales/es.json';
import enTranslation from 'assets/locales/en.json';

const resources = {
  es: {
    translation: esTranslation
  },
  en: {
    translation: enTranslation
  }
};

// Function to get language from URL path
const getLanguageFromPath = () => {
  const path = window.location.pathname;
  const segments = path.split('/').filter(Boolean);
  const language = segments[0];
  
  // Check if it's a valid language
  if (language && ['es', 'en'].includes(language)) {
    return language;
  }
  
  // Default to Spanish if no valid language in URL
  return 'es';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getLanguageFromPath(), // Get language from URL
    fallbackLng: 'es', // Default language
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already does escaping
    }
  });

export default i18n;
